import { FC, PropsWithChildren } from 'react';

import { Stack } from '@mui/material';

import useBoolean from '@src/hooks/use-boolean';
import { useResponsive } from '@src/hooks/use-responsive';

import Footer from './footer';
import Header from './header';
import Main from './main';
import SideBar from './sider-bar';
import SideBarMini from './sider-bar-mini';

type LayoutProps = PropsWithChildren;

const Layout: FC<LayoutProps> = (props) => {
  const { children } = props;

  const lgUp = useResponsive('up', 'lg');

  const miniLayout = useBoolean();

  const sideBar = useBoolean();

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        maxHeight: '100%',
      }}
      direction="row"
    >
      {lgUp && miniLayout.value ? (
        <SideBarMini />
      ) : (
        <SideBar isOpen={sideBar.value} onClose={sideBar.onFalse} />
      )}

      <Stack sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Header
          onOpen={sideBar.onTrue}
          onToggle={miniLayout.onToggle}
          isMini={miniLayout.value}
        />

        <Main isMini={miniLayout.value}>{children}</Main>

        <Footer />
      </Stack>
    </Stack>
  );
};

export default Layout;
